// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"126":"c7ce1345","323":"81aeea08","543":"e2ae3732"}[chunkId] + ".css";
};